import React from 'react'

const About = () => {
  return (
    <div className='min-h-[calc(100vh-70px)] p-8 flex flex-col items-center bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100'>
      <h2 className='text-3xl font-bold mb-8 text-center'>About RTO Bharat</h2>
      <div className='max-w-4xl space-y-6'>
        {/* <h2 className='text-xl font-semibold text-center'>
          RTO Bharat is dedicated to providing seamless and efficient digital
          transport services across India.
        </h2>
        <h2 className='text-xl font-semibold text-center'>
          Our mission is to simplify the process of vehicle registration, license
          renewal, and insurance through our user-friendly platform.
        </h2> */}
        <div className="mt-10 grid md:grid-cols-1 gap-8">
          {/* Left Section - Info */}
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
            <h3 className='text-lg font-semibold mb-4 text-blue-600 dark:text-blue-400'>Our Vision</h3>
            <p className='text-gray-700 dark:text-gray-300 leading-relaxed'>Our vision is to become a trusted digital support platform for RTO application assistance by making transport-related procedures easier, more transparent, and accessible to everyone. We aspire to use technology and customer-centric support to reduce the complexity of application processes while maintaining clarity, affordability, and professionalism. Through continuous improvement, RTO-BHARAT aims to serve individuals and vehicle owners with dependable assistance and guidance.</p>
          </div>

          {/* Right Section - Info */}
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
            <h3 className='text-lg font-semibold mb-4 text-blue-600 dark:text-blue-400'>Our Mission</h3>
            <p className='text-gray-700 dark:text-gray-300 leading-relaxed'>Our mission at RTO-BHARAT is to simplify RTO-related application processes for individuals and vehicle owners across India. We aim to provide reliable online application assistance and documentation support that helps users save time, avoid confusion, and complete required procedures smoothly. We focus on guiding customers through form filling, document preparation, and submission assistance for services such as driving licence applications, renewals, vehicle registration, and challan-related processes. RTO-BHARAT operates as an independent service provider and does not represent any government authority.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About
